export const DR_PHONE_LENGTH = 10;
export const DR_IDENTIFICATION_LENGTH = 11;
// 10MB
export const MAX_TOTAL_PDF_SIZE = 10485760;